export const onClickGsilLogo = () => {
  window.location.href = 'https://www.smartsitesafetysolution.com';
};

export const getDashboardMapLocation = (lat, lng) => {
  const pathname = '/dashboard/map';
  if (+lat && +lng && !Number.isNaN(+lat) && !Number.isNaN(+lng)) {
    return {
      pathname,
      search: `?lat=${+lat}&lng=${+lng}&time=${new Date().getTime()}`
    };
  }
  return null;
};
